"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var icon_1 = require("./icon");
var Dialog = /** @class */ (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dialog.prototype.handleBackgroundClick = function (e) {
        if (this.props.closeOnBackgroundClick) {
            var clickedElement = e.target;
            if (clickedElement && clickedElement.classList.contains("dialog-layer")) {
                this.props.onClose();
            }
        }
    };
    Dialog.prototype.xClicked = function () {
        if (this.props.onXClicked) {
            this.props.onXClicked();
        }
        else {
            this.props.onClose();
        }
    };
    Dialog.prototype.renderDialog = function () {
        var _this = this;
        var props = this.props;
        var style = { width: props.width || "500px", height: props.height || "auto" };
        return (React.createElement("div", { className: "dialog-layer" + (this.props.layerClass ? " " + this.props.layerClass : ''), onClick: function (e) { return _this.handleBackgroundClick(e); } },
            React.createElement("div", { className: "dialog" + (props.className ? " " + props.className : ""), style: style },
                !props.title &&
                    React.createElement("div", { className: "dialog-close-button-no-title", onClick: function () { return _this.xClicked(); } },
                        React.createElement(icon_1.Icon, { icon: icon_1.Icon.Icomoon.cross })),
                props.title &&
                    React.createElement("div", { className: "dialog-header" },
                        props.title,
                        React.createElement("div", { className: "dialog-close-button", onClick: function () { return _this.xClicked(); } },
                            React.createElement(icon_1.Icon, { icon: icon_1.Icon.Icomoon.cross }))),
                React.createElement("div", { className: "dialog-content", id: "dialog-content" }, props.children),
                props.footerContent && React.createElement("div", { className: "dialog-footer" }, props.footerContent))));
    };
    Dialog.prototype.componentWillReceiveProps = function (newProps) {
        if (this.props.isOpen !== newProps.isOpen) {
            var main = document.querySelector("main");
            if (!newProps.isOpen) {
                if (main && main.classList.contains("dialog-open")) {
                    main.classList.remove("dialog-open");
                }
                this.props.onClose();
            }
            else {
                if (main && !main.classList.contains("dialog-open")) {
                    main.classList.add("dialog-open");
                }
                if (this.props.onOpen) {
                    this.props.onOpen();
                }
            }
        }
    };
    Dialog.prototype.render = function () {
        return this.props.isOpen ? ReactDOM.createPortal(this.renderDialog(), document.getElementById(this.props.bodyId)) : null;
    };
    Dialog.defaultProps = {
        bodyId: "host",
    };
    return Dialog;
}(React.Component));
exports.Dialog = Dialog;
